export const getUsdtMainInfo = () => {
  // console.log("getUsdtMainInfo transaction", transaction);
};

export const getUsdtTableData = (transaction) => {
  console.log("transaction", transaction);
  return [];
};
